var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20021 12.7786L7.50021 7.47856L10.7502 10.7286C11.1602 11.1386 11.8202 11.1186 12.2002 10.6886L19.3702 2.61856C19.7202 2.22856 19.7002 1.62856 19.3302 1.24856C18.9302 0.848564 18.2602 0.858564 17.8802 1.28856L11.4902 8.46856L8.20021 5.17856C7.81021 4.78856 7.18021 4.78856 6.79021 5.17856L0.700215 11.2786C0.310215 11.6686 0.310215 12.2986 0.700215 12.6886L0.790215 12.7786C1.18021 13.1686 1.82021 13.1686 2.20021 12.7786Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGraph);
export default __webpack_public_path__ + "static/media/lineGraph.e816d95f4c8d39f4e08d89311501d7af.svg";
export { ForwardRef as ReactComponent };